export default {"src":"/login-app/[GIT_HASH]/_next/static/media/datatype_array.d8ddcd53.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};